RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const BasePlanChangeModal = Marionette.ItemView.extend({
        className: 'modal',
        attributes: {
            tabindex: -1
        },

        ui: {
            changePlanBtn: '.x-plan-change'
        },

        events: {
            'click @ui.changePlanBtn': 'changePlan'
        },

        templateHelpers: function () {

            const me = this;

            return {
                plan: me.options.plan,
                price: me.options.price
            };
        },

        changePlan: function () {

            const me = this;

            if (me.options.plan.price !== me.options.price) {
                me.options.plan.price = me.options.price;
            }

            RivalIQ.execute(me.options.handlerToExecute, {
                plan: me.options.plan
            });
        }
    });

    views.PlanChangeToAnnualModal = BasePlanChangeModal.extend({
        template: '#accountSettingsPlanChangeToAnnualModal'
    });

    views.PlanChangeToMonthlyModal = BasePlanChangeModal.extend({
        template: '#accountSettingsMonthlyToMonthlyPlanChangeModal'
    });
});
